var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9996 8.3335C26.9879 8.3335 8.33301 26.9884 8.33301 50.0001C8.33301 73.0118 26.9879 91.6669 49.9996 91.6669C73.0113 91.6669 91.6664 73.0118 91.6664 50.0001C91.6664 26.9884 73.0115 8.3335 49.9996 8.3335ZM49.9996 83.3335C31.6197 83.3335 16.6664 68.3802 16.6664 50.0001C16.6664 31.62 31.6195 16.6669 49.9996 16.6669C68.3797 16.6669 83.333 31.62 83.333 50.0001C83.333 68.3802 68.3797 83.3335 49.9996 83.3335ZM65.6902 35.1136L71.5822 41.0056L45.833 66.8626L30.3871 51.4167L36.2789 45.5247L45.833 55.0788L65.6902 35.1136Z",
    fill: "#09AA6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success_icon.e26e306da8ab053d142e3ac2e63ca72d.svg";
export { ForwardRef as ReactComponent };